import _ from 'lodash';
import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';
import { captureMessage, Severity } from '@sentry/react';

import { API, SET_OFFLINE_MODE, SET_STORY, UPDATE_ANSWERS } from 'client/constants/actions';
import { getAvatar } from './avatar';

type UserState = {
	isRegistered: boolean;
	isOffline: boolean;
	storyPageViewId: null | string;
	answers: {
		// cardID
		[key: string]:
			| {
					selected: string[];
					votes: {
						// answerId
						[key: string]: number;
					};
			  }
			| undefined;
	};
	email?: string;
	google?: {
		email: string;
		id: string;
		name: string;
		picture: string;
	};
	facebook?: { id: string };
	sms?: {
		id: string;
		phone: string;
		picture: string;
	};
	guest?: boolean;
	id?: string;
	organizationId?: string;
	provider?: 'google' | 'sms';

	// available only if "oncePerUser: true"
	checkpoint?: {
		cardId: string;
		date: string;
	};
};

const initialState: UserState = {
	isRegistered: false,
	isOffline: false,
	storyPageViewId: null,
	answers: {},
};

export default function userReducer(state = initialState, { type, payload }): UserState {
	return produce(state, draft => {
		switch (type) {
			/* eslint-disable no-param-reassign */
			case API.GET_USER_DATA.SUCCESS:
				Object.assign(draft, {
					isRegistered: _.has(payload, 'id'),
					...payload,
				});
				if (payload.provider === 'sms') {
					draft.sms = {
						id: payload.id,
						phone: payload.phone,
						picture: getAvatar(),
					};
				}
				break;

			case API.REGISTER_GUEST.SUCCESS:
				_.set(draft, 'isRegistered', true);
				break;

			case SET_OFFLINE_MODE:
				_.set(draft, 'isOffline', payload);
				break;

			case SET_STORY:
				_.set(draft, 'storyPageViewId', uuidv4());
				break;

			case API.GET_GAME.SUCCESS:
			case API.START_GAME.SUCCESS:
				if (payload?.game) {
					if (!payload.game?.pageViewId) {
						captureMessage(`[DEBUG] pageViewId is undefined`, {
							level: Severity.Error,
							contexts: {
								data: {
									type,
									game: payload.game,
								},
							},
						});
					}
					_.set(draft, 'storyPageViewId', payload.game.pageViewId);
					_.set(draft, 'checkpoint', payload.game.checkpoint);
				}
				break;

			case UPDATE_ANSWERS:
				draft.answers[payload.cardId] = {
					selected: [...(draft.answers[payload.cardId]?.selected || []), payload.answerId],
					votes: payload.votes,
				};
				break;

			default:
				break;
			/* eslint-enable no-param-reassign */
		}
	});
}
